import { render, staticRenderFns } from "./FluxPage.vue?vue&type=template&id=1f1bcef8&"
import script from "./FluxPage.vue?vue&type=script&lang=js&"
export * from "./FluxPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports